export default import.meta.glob([
  "./persistable/*.js",
  "!./model.js",
  "!./get-model.js",
  "!./require-models.js"
], { eager: true });
